import { useNow } from "@/features/time/hooks/useNow";
import { elapsedSeconds, formatClock } from "@/shared/lib/duration";
import { useLocale } from "@/shared/i18n/useT";
import { cn } from "@/shared/lib/cn";

interface TimerClockProps {
  startedAt: string;
  className?: string;
}

/**
 * How long a timer has run, ticking every second while the page is visible. Screen readers
 * hear the start time once, not a new number every second.
 */
export function TimerClock({ startedAt, className }: TimerClockProps) {
  const { locale } = useLocale();
  const now = useNow(true);
  return (
    <time
      dateTime={startedAt}
      dir="ltr"
      aria-hidden="true"
      className={cn("font-semibold tabular-nums", className)}
    >
      {formatClock(elapsedSeconds(startedAt, now), locale)}
    </time>
  );
}
